module.exports = __webpack_public_path__ + "static/media/background1.6fe049aa.jpg";